<template>
    <v-card>
        <div style="text-align: center">
            <img src="../assets/logo.png" alt="Logo" class="img-fluid" />
            <h2>Change Password</h2>
        </div>
        <v-form>
            <v-container>
                <fieldset>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">New Password</label>
                            <v-text-field v-model="data.new_password" label="New Password" placeholder="New Password"
                                solo type="password"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">Confirm Password</label>
                            <v-text-field v-model="data.confirm_password" label="Confirm Password"
                                placeholder="Confirm Password" solo type="password"></v-text-field>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn :loading="loading" color="primary" @click="updatePassword">Save</v-btn>
                        </v-col>
                    </v-row>
                </fieldset>
            </v-container>
        </v-form>
    </v-card>
</template>

<script>

export default {
    name: "changePasswordForm",
    data() {
        return {
            loading: false,
            data: {},
        };
    },
    methods: {
        updatePassword() {
            if (this.data.new_password != this.data.confirm_password) {
                alert('Password mismatch error!');
                return;
            }
            if (typeof (this.data.new_password) == "undefined") {
                alert('All fields are required!');
                return;
            }
            if (typeof (this.data.confirm_password) == "undefined") {
                alert('All fields are required!');
                return;
            }
            this.loading = true
            axios.post("change/password", this.data).then(response => {
                localStorage.clear();
                this.$router.replace({ name: "Login" });
                location.reload()
            }).catch(response => {

            })
        }
    },
    created() {

    }
};
</script>

<style lang="scss" scoped>
fieldset {
    border: 0;

    &:not(:last-of-type) {
        border-bottom: 1px dashed #8898aa80;
        margin-bottom: 20px;
    }

    & legend {
        font: Bold 20px/25px Lato;
        color: #172b4d;
    }

    & label {
        font: Bold 15px/40px Lato;
        color: #172b4d;
    }
}
</style>